import _ from 'lodash';
import { prepareBaseAutoSaveData, resolveAutoSaveSanitizeOptions } from './shared';
import { createJsonConfiguredAutoSaveAdapter } from './jsonAutoSave';

const prepareIndividualEddData = (data, autoSaveConfig) => prepareBaseAutoSaveData(
    data,
    resolveAutoSaveSanitizeOptions(autoSaveConfig)
);
export const createIndividualEddAutoSaveAdapter = (applicationForm, fieldDefinitions = {}, autoSaveConfig = null) => createJsonConfiguredAutoSaveAdapter({
    autoSaveConfig: _.cloneDeep(autoSaveConfig || {}),
    fieldDefinitions: _.cloneDeep(fieldDefinitions || {}),
    runtimeRecords: {
        applicationForm,
    },
    prepareData(data) {
        return prepareIndividualEddData(data, autoSaveConfig);
    },
});
